"use client";

import React from "react";
import { PhoneCall, MessageCircle, Wrench, ShieldCheck, Flame, Clock, MapPin, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { PHONE_LOCAL, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
const benefits = [{
  icon: Flame,
  title: "إصلاح شعلات ومفاتيح الخزف السعودي",
  description: "معالجة ضعف النار، انسداد الفواني، وصيانة مفاتيح وشعلات الفرن والعيون العلوية بدقة."
}, {
  icon: ShieldCheck,
  title: "قطع غيار أصلية وضمان معتمد",
  description: "توفير تبديل الحساسات، الزجاج الحراري، ومفاتيح التحكم مع ضمان فني معتمد على العمل."
}, {
  icon: Clock,
  title: "خدمة منزلية فورية في الرياض",
  description: "فريق فني متخصص يصلك لباب منزلك في كافة أحياء الرياض لإجراء الفحص والإصلاح المباشر."
}, {
  icon: Wrench,
  title: "تنظيف وإزالة الدهون المستعصية",
  description: "تنظيف شامل للمنظومة الداخلية وتفتيت الشحوم لضمان كفاءة واحتراق آمن وخالٍ من الدخان."
}];
const highlights = ["فحص وصيانة أفران الغاز والكهرباء من ماركة الخزف السعودي", "معالجة انطفاء الفرن المفاجئ ومشاكل ثرموستات الحرارة", "طاقم فني محترف يغطي كافة أحياء الرياض يومياً"];
export default function HeroAlKhazafRepair() {
  return <section id="heroalkhazafrepair" data-nav="light" dir="rtl" className="relative bg-background text-foreground py-12 lg:py-20 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          
          {/* Main Hero Column */}
          <div className="lg:col-span-7 flex flex-col items-start text-right">
            <Badge variant="outline" className="mb-4 px-3 py-1 text-sm bg-accent/60 border-primary/20 text-foreground flex items-center gap-1.5">
              <MapPin className="size-3.5 text-primary" />
              <span>خدمة منزلية معتمدة داخل الرياض</span>
            </Badge>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight">
              صيانة أفران الخزف السعودي بالرياض بمهارة واحترافية عالية
            </h1>

            <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
              نقدم في لمسة احتراف خدمات فحص، إصلاح وتنظيف شاملة متخصصة في صيانة أفران الخزف السعودي المنزلية. نتولى معالجة انسداد العيون وضعف الشعلة، استبدال الترموستات، وتوفير قطع الغيار الأصلية فورا عند باب منزلك في الرياض.
            </p>

            {/* Checklist */}
            <div className="mt-6 space-y-2.5 w-full">
              {highlights.map((item, idx) => <div key={idx} data-index={idx} className="flex items-center gap-2.5 text-sm sm:text-base text-foreground/90">
                  <CheckCircle2 className="size-4.5 text-primary shrink-0" />
                  <span>{item}</span>
                </div>)}
            </div>

            {/* Primary Action Buttons */}
            <div className="mt-8 flex flex-wrap items-center gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto font-medium">
                <a href={PHONE_TEL_HREF} className="flex items-center justify-center gap-2">
                  <PhoneCall className="size-4.5" />
                  <span>اتصل الآن: {PHONE_LOCAL}</span>
                </a>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-border hover:bg-muted font-medium">
                <Link to={WHATSAPP_HREF} newTab className="flex items-center justify-center gap-2">
                  <MessageCircle className="size-4.5 text-chart-4" />
                  <span>محادثة واتساب مباشرة</span>
                </Link>
              </Button>
            </div>
          </div>

          {/* Side Visual / Highlights Grid */}
          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden border border-border bg-card p-6 shadow-md">
              <div className="relative z-10 space-y-4">
                <div className="pb-3 border-b border-border">
                  <h2 className="text-xl font-bold text-card-foreground">
                    خدمات صيانة أفران الخزف السعودي
                  </h2>
                  <p className="text-xs sm:text-sm text-muted-foreground mt-1">
                    حلول فورية وأمان عالي داخل منزلك في الرياض
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-3">
                  {benefits.map((benefit, i) => {
                  const IconComponent = benefit.icon;
                  return <div key={i} data-index={i} className="flex items-start gap-3 p-3 rounded-lg bg-muted/60 hover:bg-muted transition-colors border border-border/40">
                        <div className="p-2 rounded-md bg-primary/10 text-primary shrink-0 mt-0.5">
                          <IconComponent className="size-5" />
                        </div>
                        <div>
                          <h3 className="text-sm font-semibold text-card-foreground">
                            {benefit.title}
                          </h3>
                          <p className="text-xs text-muted-foreground mt-0.5 leading-normal">
                            {benefit.description}
                          </p>
                        </div>
                      </div>;
                })}
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom CTA Band */}
        <div className="mt-14 rounded-xl bg-secondary text-secondary-foreground p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-6 shadow-sm">
          <div className="text-right">
            <h3 className="text-lg sm:text-xl font-bold text-secondary-foreground">
              هل تواجه عطلا في فرن الخزف السعودي بمنزلك؟
            </h3>
            <p className="text-sm text-secondary-foreground/80 mt-1">
              فنيو لمسة احتراف مستعدون لمعاينة وصيانة الفرن فوراً في أي حي داخل الرياض.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3 shrink-0 w-full sm:w-auto">
            <Button asChild variant="default" className="w-full sm:w-auto">
              <a href={PHONE_TEL_HREF} className="flex items-center gap-2">
                <PhoneCall className="size-4" />
                <span>طلب صيانة فورية</span>
              </a>
            </Button>
            <Button asChild variant="secondary" className="w-full sm:w-auto bg-secondary-foreground/10 text-secondary-foreground hover:bg-secondary-foreground/20 border border-secondary-foreground/20">
              <Link to={WHATSAPP_HREF} newTab className="flex items-center gap-2">
                <MessageCircle className="size-4" />
                <span>واتساب</span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}